import { NEW_ENDPOINTS } from '@constants'
import { AxiosRequestConfig } from 'axios'
import { BaseApi } from './_base.api'

export class DashboardApi extends BaseApi {
  getData = (params?: AxiosRequestConfig['params']) =>
    this.api.get(NEW_ENDPOINTS.DASHBOARD, params).then(res => res.data.data)
}
